<template lang="html">
  <section class="app-crud-card">
    <b-card no-body>
      <b-card-header header-tag="nav" class="card-header">
        <b-nav card-header tabs class="menu">
          <b-nav-item @click="setPreviousOperation(getOperation) || setOperation(operation) || setCurrentElement(null)" v-for="operation in crud" :key="operation"
                      class="menu-item text-capitalize" :active="getOperation === operation">
            {{ operation }}
          </b-nav-item>
        </b-nav>
      </b-card-header>
      <b-card-body class="text-center">
          <component :is="setCrudComponent('app-' + getOperation + '-' + getComponent.split('_').join('-')) || getCrudComponent">
          </component>
      </b-card-body>
    </b-card>
  </section>
</template>

<script lang="js">
import CreateAward from '../awards/CreateAward'
import ReadAward from '../awards/ReadAward'
import UpdateAward from '../awards/UpdateAward'
import DeleteAward from '../awards/DeleteAward'
import CreateGallery from '../galleries/CreateGallery'
import ReadGallery from '../galleries/ReadGallery'
import UpdateGallery from '../galleries/UpdateGallery'
import DeleteGallery from '../galleries/DeleteGallery'
import CreateNewsType from '../news_types/CreateNewsType'
import ReadNewsType from '../news_types/ReadNewsType'
import UpdateNewsType from '../news_types/UpdateNewsType'
import DeleteNewsType from '../news_types/DeleteNewsType'
import CreateNews from '../news/CreateNews'
import ReadNews from '../news/ReadNews'
import UpdateNews from '../news/UpdateNews'
import DeleteNews from '../news/DeleteNews'
import CreateProject from '../projects/CreateProject'
import ReadProject from '../projects/ReadProject'
import UpdateProject from '../projects/UpdateProject'
import DeleteProject from '../projects/DeleteProject'
import CreateSubscriber from '../subscribers/CreateSubscriber'
import ReadSubscriber from '../subscribers/ReadSubscriber'
import UpdateSubscriber from '../subscribers/UpdateSubscriber'
import DeleteSubscriber from '../subscribers/DeleteSubscriber'
import CreateProjectsType from '../projects_types/CreateProjectsType'
import ReadProjectsType from '../projects_types/ReadProjectsType'
import UpdateProjectsType from '../projects_types/UpdateProjectsType'
import DeleteProjectsType from '../projects_types/DeleteProjectsType'
import CreateMail from '../mails/CreateMail'
import ReadMail from '../mails/ReadMail'
import UpdateMail from '../mails/UpdateMail'
import DeleteMail from '../mails/DeleteMail'
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'CrudCard',
  props: [],
  mounted () {},
  created() {
    this.crud = this.getCrudOperations
  },
  data () {
    return {
      crud: null
    }
  },
  methods: {
    ...mapMutations([
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'setCurrentElement'
    ])
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getOperation',
      'getCrudOperations',
      'getCrudComponent',
      'getPreviousOperation'
    ])
  },
  components: {
    AppCreateAwards: CreateAward,
    AppReadAwards: ReadAward,
    AppUpdateAwards: UpdateAward,
    AppDeleteAwards: DeleteAward,
    AppCreateGalleries: CreateGallery,
    AppReadGalleries: ReadGallery,
    AppUpdateGalleries: UpdateGallery,
    AppDeleteGalleries: DeleteGallery,
    AppCreateNewsTypes: CreateNewsType,
    AppReadNewsTypes: ReadNewsType,
    AppUpdateNewsTypes: UpdateNewsType,
    AppDeleteNewsTypes: DeleteNewsType,
    AppCreateNews: CreateNews,
    AppReadNews: ReadNews,
    AppUpdateNews: UpdateNews,
    AppDeleteNews: DeleteNews,
    AppCreateProjectsTypes: CreateProjectsType,
    AppReadProjectsTypes: ReadProjectsType,
    AppUpdateProjectsTypes: UpdateProjectsType,
    AppDeleteProjectsTypes: DeleteProjectsType,
    AppCreateProjects: CreateProject,
    AppReadProjects: ReadProject,
    AppUpdateProjects: UpdateProject,
    AppDeleteProjects: DeleteProject,
    AppCreateSubscribers: CreateSubscriber,
    AppReadSubscribers: ReadSubscriber,
    AppUpdateSubscribers: UpdateSubscriber,
    AppDeleteSubscribers: DeleteSubscriber,
    AppCreateMails: CreateMail,
    AppReadMails: ReadMail,
    AppUpdateMails: UpdateMail,
    AppDeleteMails: DeleteMail
  }
}
</script>

<style scoped lang="scss">
  .app-crud-card {}
  .card-header {
    background-color: var(--dark-color);
  }
  .nav-link.active{
    color: var(--dark-color);
  }
  .nav-link{
    color: var(--white-color);
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/CrudCard.vue